(function () {
  function initBenefitCarousels() {
    var lists = document.querySelectorAll('[data-benefit-carousel]');
    if (!lists.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var TRANSITION_MS = 450;
    var INTERVAL_MS = 2800;

    lists.forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
      if (items.length < 2 || prefersReducedMotion) return;

      var index = 0;
      var intervalId = null;

      function reset() {
        items.forEach(function (item, i) {
          item.classList.remove('is-active', 'is-exiting');
          item.style.transition = 'none';
          if (i === 0) item.classList.add('is-active');
          // Force reflow so the 'none' transition actually applies before we restore it.
          void item.offsetWidth;
          item.style.transition = '';
        });
        index = 0;
      }

      function next() {
        var current = items[index];
        var newIndex = (index + 1) % items.length;
        var incoming = items[newIndex];

        // Current item always exits left; incoming item always enters from the right —
        // this direction never reverses, even when wrapping from the last item back to the first.
        current.classList.remove('is-active');
        current.classList.add('is-exiting');
        incoming.classList.add('is-active');

        window.setTimeout(function () {
          // Snap the exited item back to its parked position (off-screen right),
          // instantly and without animating, so it's ready to enter from the right again next time.
          current.style.transition = 'none';
          current.classList.remove('is-exiting');
          void current.offsetWidth;
          current.style.transition = '';
        }, TRANSITION_MS + 20);

        index = newIndex;
      }

      function start() {
        if (intervalId) return;
        reset();
        intervalId = setInterval(next, INTERVAL_MS);
      }

      function stop() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      function handleChange() {
        if (mobileQuery.matches) {
          start();
        } else {
          stop();
        }
      }

      handleChange();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleChange);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(handleChange);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!mobileQuery.matches) return;
              if (entry.isIntersecting) {
                start();
              } else {
                stop();
              }
            });
          },
          { threshold: 0.25 }
        );
        observer.observe(list);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitCarousels);
  } else {
    initBenefitCarousels();
  }
})();